/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from "vue";
import Vuex from "vuex";
import userApi from "~/api/user";
import ROUTE from "~/constants/routes";
import router from "~/router";
import { setAuthData, logOut, setUserData } from "../helpers/userAuth";
Vue.use(Vuex);

const state = {
  userInfo: null,

  users: {},
  usersList: [],

  user: null,

  teams: {},
  teamsList: [],

  teamUsers: {},
  teamUsersList: [],

  spending: {},
  spendingList: [],

  error: {},
  validationErrors: {},
  loadingProcess: false,
  successRegistration: false,
};

const mutations = {
  setError: (state, payload) => {
    state.error = payload;
  },
  setLoading: (state, payload) => {
    state.loadingProcess = payload;
  },
  setValidationErrors: (state, payload) => {
    state.validationErrors = payload;
  },

  setUsersList: (state, payload) => {
    state.usersList = payload;
  },
  setUsers: (state, payload) => {
    state.users = payload;
  },

  setTeamsList: (state, payload) => {
    state.teamsList = payload;
  },
  setTeams: (state, payload) => {
    state.teams = payload;
  },

  setTeamUsersList: (state, payload) => {
    state.teamUsersList = payload;
  },
  setTeamUsers: (state, payload) => {
    state.teamUsers = payload;
  },

  setSpendingList: (state, payload) => {
    state.spendingList = payload;
  },
  setSpending: (state, payload) => {
    state.spending = payload;
  },

  setSuccessRegistration: (state, payload) => {
    state.successRegistration = payload;
  },
};

const actions = {
  login({ commit, dispatch }, payload) {
    commit("setLoading", true);
    commit("setError", {});
    commit("setValidationErrors", {});

    userApi
      .login(payload)
      .then((res) => {
        setAuthData(res.data.data.accessToken, res.data.data.expiresIn, {});
        dispatch("getUser");
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  registration({ commit, dispatch }, payload) {
    commit("setLoading", true);
    commit("setError", {});
    commit("setValidationErrors", {});

    userApi
      .registration(payload)
      .then((res) => {
        commit("setSuccessRegistration", true);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  logout({ commit }) {
    commit("setLoading", true);
    userApi
      .logout()
      .then((res) => {
        logOut();
        router.push("/login");
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getUser({ commit }) {
    userApi
      .getProfile()
      .then((res) => {
        setUserData(res.data.data);
        router.push("/");
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      });
  },

  getUsersList({ commit }, payload) {
    commit("setLoading", true);
    userApi
      .getUsersList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const users = res.data.data;
        for (let i = 0; users.length > i; i++) {
          users[i].groups = users[i]?.groups[0]?.name;
        }
        commit("setUsersList", users);
        commit("setUsers", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createUser({ commit }, payload) {
    commit("setLoading", true);
    userApi
      .createUser(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          if (payload.team_id) {
            router.push({
              path: ROUTE.TEAM_DETAIL.replace(":id", payload.team_id).replace(":page", 1),
            });
          } else {
            router.push({
              path: ROUTE.USER_LIST.replace(":page", 1),
            });
          }
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editUser({ commit }, { url, editData }) {
    commit("setLoading", true);
    userApi
      .editUser(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          if (editData.team_id) {
            router.push({
              path: ROUTE.TEAM_DETAIL.replace(":id", editData.team_id).replace(":page", 1),
            });
          } else {
            router.push({
              path: ROUTE.USER_LIST.replace(":page", 1),
            });
          }
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getTeamList({ commit }, payload) {
    commit("setLoading", true);
    userApi
      .getTeamList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const teams = res.data.data;
        for (let i = 0; teams.length > i; i++) {
          teams[i].lead = teams[i]?.lead?.name;
        }
        commit("setTeamsList", teams);
        commit("setTeams", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createTeam({ commit }, payload) {
    commit("setLoading", true);
    userApi
      .createTeam(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.TEAM_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editTeam({ commit }, { url, editData }) {
    commit("setLoading", true);
    userApi
      .editTeam(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.TEAM_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getTeamUsersList({ commit }, payload) {
    commit("setLoading", true);
    userApi
      .getUserTeamList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const teamUsers = res.data.data;
        for (let i = 0; teamUsers.length > i; i++) {}
        commit("setTeamUsersList", teamUsers);
        commit("setTeamUsers", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getSpendingList({ commit }, payload) {
    commit("setLoading", true);
    userApi
      .getSpendingList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const spending = res.data.data;
        for (let i = 0; spending.length > i; i++) {
          if (
            spending[i].buyer &&
            typeof spending[i].buyer === "object" &&
            !Array.isArray(spending[i].buyer)
          ) {
            spending[i].buyer_name = spending[i].buyer.email;

            if (spending[i].buyer.teams.length > 0) {
              spending[i].team_name = spending[i].buyer.teams[0].name;
            }
          }
        }
        commit("setSpendingList", spending);
        commit("setSpending", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
};

const getters = {};

const users = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
export default users;
